module.exports = __webpack_public_path__ + "static/houston-356bd2a9a75b44bdf7897b2cdd387600.png";